<template>
  <div>
    <div class="row">
      <div class="col">
        <b-alert show variant="success">
          {{ $t("tasks.assignee", {
          firstName: assignee.firstName,
          lastName: assignee.lastName,
          department: assignee.department,
          }) }}
        </b-alert>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 m-2">
        <button
          type="button"
          class="btn btn-primary"
          @click="completeTask()"
          >
          {{ $t("tasks.status.complete-task-button") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { taskService } from '@/helpers/services/tasks/taskService';


export default {
  props: {
    taskId: {
      type: String,
      required: true,
    },
  },
  name: "TaskAssigned",
  data() {
    return {
      assignee: {
        firstName: "",
        lastName: "",
        departmentTitle: "",
      },
    }
  },
  methods: {
    completeTask() {
      this.$emit("completeTask");
    },
  },
  created() {
    taskService.fetchTaskAssignee(this.taskId)
      .then(a => this.assignee = a);
  }
}
</script>